export default [
  {
    value: 'AF',
    label: 'Afghanistan',
  },
  {
    value: 'AL',
    label: 'Albanien',
  },
  {
    value: 'DZ',
    label: 'Algerien',
  },
  {
    value: 'AS',
    label: 'Amerikanischen Samoa-Inseln',
  },
  {
    value: 'AD',
    label: 'Andorra',
  },
  {
    value: 'AO',
    label: 'Angola',
  },
  {
    value: 'AI',
    label: 'Anguilla',
  },
  {
    value: 'AG',
    label: 'Antigua und Barbuda',
  },
  {
    value: 'AR',
    label: 'Argentinien',
  },
  {
    value: 'AM',
    label: 'Armenien',
  },
  {
    value: 'AW',
    label: 'Aruba',
  },
  {
    value: 'AU',
    label: 'Australien',
  },
  {
    value: 'AT',
    label: 'Österreich',
  },
  {
    value: 'AZ',
    label: 'Aserbaidschan',
  },
  {
    value: 'BS',
    label: 'Bahamas',
  },
  {
    value: 'BH',
    label: 'Bahrain',
  },
  {
    value: 'BD',
    label: 'Bangladesch',
  },
  {
    value: 'BB',
    label: 'Barbados',
  },
  {
    value: 'BY',
    label: 'Weißrussland',
  },
  {
    value: 'BE',
    label: 'Belgien',
  },
  {
    value: 'BZ',
    label: 'Belize',
  },
  {
    value: 'BJ',
    label: 'Benin',
  },
  {
    value: 'BM',
    label: 'Bermuda',
  },
  {
    value: 'BT',
    label: 'Bhutan',
  },
  {
    value: 'BO',
    label: 'Bolivien',
  },
  {
    value: 'BA',
    label: 'Bosnien und Herzegowina',
  },
  {
    value: 'BW',
    label: 'Botswana',
  },
  {
    value: 'BR',
    label: 'Brasilien',
  },
  {
    value: 'IO',
    label: 'Britische Jungferninseln',
  },
  {
    value: 'BN',
    label: 'Brunei Darussalam',
  },
  {
    value: 'BG',
    label: 'Bulgarien',
  },
  {
    value: 'BF',
    label: 'Burkina Faso',
  },
  {
    value: 'BI',
    label: 'Burundi',
  },
  {
    value: 'CV',
    label: 'Cabo Verde',
  },
  {
    value: 'KH',
    label: 'Kambodscha',
  },
  {
    value: 'CM',
    label: 'Kamerun',
  },
  {
    value: 'CA',
    label: 'Kanada',
  },
  {
    value: 'KY',
    label: 'Cayman Inseln',
  },
  {
    value: 'CF',
    label: 'Zentralafrikanische Republik',
  },
  {
    value: 'TD',
    label: 'Tschad',
  },
  {
    value: 'CL',
    label: 'Chile',
  },
  {
    value: 'CN',
    label: 'China',
  },
  {
    value: 'CO',
    label: 'Kolumbien',
  },
  {
    value: 'KM',
    label: 'Komoros',
  },
  {
    value: 'CG',
    label: 'Kongo',
  },
  {
    value: 'CK',
    label: 'Cookinseln',
  },
  {
    value: 'CR',
    label: 'Costa Rica',
  },
  {
    value: 'CI',
    label: "Côte d'Ivoire",
  },
  {
    value: 'HR',
    label: 'Kroatien',
  },
  {
    value: 'CU',
    label: 'Kuba',
  },
  {
    value: 'CU',
    label: 'Curacao',
  },
  {
    value: 'CY',
    label: 'Zypern',
  },
  {
    value: 'CZ',
    label: 'Tschechien',
  },
  {
    value: 'CZ',
    label: 'Demokratische Volksrepublik Korea',
  },
  {
    value: 'CD',
    label: 'Demokratische Republik Kongo',
  },
  {
    value: 'DK',
    label: 'Dänemark',
  },
  {
    value: 'DK',
    label: 'Diego Garcia',
  },
  {
    value: 'DJ',
    label: 'Dschibuti',
  },
  {
    value: 'DM',
    label: 'Dominica',
  },
  {
    value: 'DO',
    label: 'Dominikanische Republik',
  },
  {
    value: 'EC',
    label: 'Ecuador',
  },
  {
    value: 'EG',
    label: 'Ägypten',
  },
  {
    value: 'SV',
    label: 'El Salvador',
  },
  {
    value: 'GQ',
    label: 'Äquatorialguinea',
  },
  {
    value: 'ER',
    label: 'Eritrea',
  },
  {
    value: 'EE',
    label: 'Estland',
  },
  {
    value: 'EE',
    label: 'Eswatini',
  },
  {
    value: 'ET',
    label: 'Äthiopien',
  },
  {
    value: 'FK',
    label: 'Falkland Inseln',
  },
  {
    value: 'FO',
    label: 'Färöer Inseln',
  },
  {
    value: 'FJ',
    label: 'Fidschi',
  },
  {
    value: 'FI',
    label: 'Finnland',
  },
  {
    value: 'FR',
    label: 'Frankreich',
  },
  {
    value: 'FR',
    label: 'Französische Abteilungen und Gebiete im Indischen Ozean',
  },
  {
    value: 'GF',
    label: 'Französisch-Guayana',
  },
  {
    value: 'PF',
    label: 'Französisch Polynesien',
  },
  {
    value: 'GA',
    label: 'Gabon',
  },
  {
    value: 'GM',
    label: 'Gambia',
  },
  {
    value: 'GE',
    label: 'Georgia',
  },
  {
    value: 'DE',
    label: 'Deutschland',
  },
  {
    value: 'GH',
    label: 'Ghana',
  },
  {
    value: 'GI',
    label: 'Gibraltar',
  },
  {
    value: 'GR',
    label: 'Griechenland',
  },
  {
    value: 'GL',
    label: 'Grönland',
  },
  {
    value: 'GD',
    label: 'Grenada',
  },
  {
    value: 'GP',
    label: 'Guadeloupe',
  },
  {
    value: 'GU',
    label: 'Guam',
  },
  {
    value: 'GT',
    label: 'Guatemala',
  },
  {
    value: 'GG',
    label: 'Guinea',
  },
  {
    value: 'GN',
    label: 'Guinea-Bissau',
  },
  {
    value: 'GY',
    label: 'Guyana',
  },
  {
    value: 'HT',
    label: 'Haiti',
  },
  {
    value: 'HN',
    label: 'Honduras',
  },
  {
    value: 'HK',
    label: 'Hongkong',
  },
  {
    value: 'HU',
    label: 'Ungarn',
  },
  {
    value: 'IS',
    label: 'Island',
  },
  {
    value: 'IN',
    label: 'Indien',
  },
  {
    value: 'ID',
    label: 'Indonesien',
  },
  {
    value: 'IR',
    label: 'Iran',
  },
  {
    value: 'IQ',
    label: 'Irak',
  },
  {
    value: 'IE',
    label: 'Irland',
  },
  {
    value: 'IL',
    label: 'Israel',
  },
  {
    value: 'IT',
    label: 'Italien',
  },
  {
    value: 'JM',
    label: 'Jamaika',
  },
  {
    value: 'JP',
    label: 'Japan',
  },
  {
    value: 'JO',
    label: 'Jordanien',
  },
  {
    value: 'KZ',
    label: 'Kasachstan',
  },
  {
    value: 'KE',
    label: 'Kenia',
  },
  {
    value: 'KI',
    label: 'Kiribati',
  },
  {
    value: 'KR',
    label: 'Korea',
  },
  {
    value: 'XK',
    label: 'Kosovo',
  },
  {
    value: 'KW',
    label: 'Kuwait',
  },
  {
    value: 'KG',
    label: 'Kirgisistan',
  },
  {
    value: 'LA',
    label: 'Lao Volks demokratische Republik',
  },
  {
    value: 'LV',
    label: 'Lettland',
  },
  {
    value: 'LB',
    label: 'Libanon',
  },
  {
    value: 'LS',
    label: 'Lesotho',
  },
  {
    value: 'LR',
    label: 'Liberia',
  },
  {
    value: 'LY',
    label: 'Libyen',
  },
  {
    value: 'LI',
    label: 'Liechtenstein',
  },
  {
    value: 'LT',
    label: 'Litauen',
  },
  {
    value: 'LU',
    label: 'Luxemburg',
  },
  {
    value: 'MO',
    label: 'Macao',
  },
  {
    value: 'MG',
    label: 'Madagaskar',
  },
  {
    value: 'MW',
    label: 'Malawi',
  },
  {
    value: 'MY',
    label: 'Malaysia',
  },
  {
    value: 'MV',
    label: 'Malediven',
  },
  {
    value: 'ML',
    label: 'Mali',
  },
  {
    value: 'MT',
    label: 'Malta',
  },
  {
    value: 'MH',
    label: 'Marshallinseln',
  },
  {
    value: 'MQ',
    label: 'Martinique',
  },
  {
    value: 'MR',
    label: 'Mauretanien',
  },
  {
    value: 'MU',
    label: 'Mauritius',
  },
  {
    value: 'MX',
    label: 'Mexiko',
  },
  {
    value: 'FM',
    label: 'Mikronesien',
  },
  {
    value: 'MD',
    label: 'Moldawien',
  },
  {
    value: 'MC',
    label: 'Monaco',
  },
  {
    value: 'MN',
    label: 'Mongolei',
  },
  {
    value: 'ME',
    label: 'Montenegro',
  },
  {
    value: 'MS',
    label: 'Montserrat',
  },
  {
    value: 'MA',
    label: 'Marokko',
  },
  {
    value: 'MZ',
    label: 'Mosambik',
  },
  {
    value: 'MM',
    label: 'Myanmar',
  },
  {
    value: 'NA',
    label: 'Namibia',
  },
  {
    value: 'NR',
    label: 'Nauru',
  },
  {
    value: 'NP',
    label: 'Nepal',
  },
  {
    value: 'NL',
    label: 'Niederlande',
  },
  {
    value: 'NC',
    label: 'Neu-Kaledonien',
  },
  {
    value: 'NZ',
    label: 'Neuseeland',
  },
  {
    value: 'NI',
    label: 'Nicaragua',
  },
  {
    value: 'NE',
    label: 'Niger',
  },
  {
    value: 'NG',
    label: 'Nigeria',
  },
  {
    value: 'NU',
    label: 'Niue',
  },
  {
    value: 'NF',
    label: 'Norfolkinsel',
  },
  {
    value: 'NF',
    label: 'Nord -Mazedonien',
  },
  {
    value: 'MP',
    label: 'Nördliche Marianneninseln',
  },
  {
    value: 'NO',
    label: 'Norwegen',
  },
  {
    value: 'OM',
    label: 'Oman',
  },
  {
    value: 'PK',
    label: 'Pakistan',
  },
  {
    value: 'PW',
    label: 'Palau',
  },
  {
    value: 'PA',
    label: 'Panama',
  },
  {
    value: 'PG',
    label: 'Papua Neu-Guinea',
  },
  {
    value: 'PY',
    label: 'Paraguay',
  },
  {
    value: 'PE',
    label: 'Peru',
  },
  {
    value: 'PH',
    label: 'Philippinen',
  },
  {
    value: 'PL',
    label: 'Polen',
  },
  {
    value: 'PT',
    label: 'Portugal',
  },
  {
    value: 'PR',
    label: 'Puerto Rico',
  },
  {
    value: 'QA',
    label: 'Katar',
  },
  {
    value: 'RO',
    label: 'Rumänien',
  },
  {
    value: 'RU',
    label: 'Russische Föderation',
  },
  {
    value: 'RW',
    label: 'Ruanda',
  },
  {
    value: 'SH',
    label: 'Saint Helena, Ascension und Tristan da Cunha',
  },
  {
    value: 'KN',
    label: 'St. Kitts und Nevis',
  },
  {
    value: 'LC',
    label: 'Saint Lucia',
  },
  {
    value: 'PM',
    label: 'Saint Pierre und Miquelon',
  },
  {
    value: 'VC',
    label: 'St. Vincent und die Grenadinen',
  },
  {
    value: 'WS',
    label: 'Samoa',
  },
  {
    value: 'SM',
    label: 'San Marino',
  },
  {
    value: 'ST',
    label: 'Sao Tome und Principe',
  },
  {
    value: 'SA',
    label: 'Saudi-Arabien',
  },
  {
    value: 'SN',
    label: 'Senegal',
  },
  {
    value: 'RS',
    label: 'Serbien',
  },
  {
    value: 'SC',
    label: 'Seychellen',
  },
  {
    value: 'SL',
    label: 'Sierra Leone',
  },
  {
    value: 'SG',
    label: 'Singapur',
  },
  {
    value: 'SG',
    label: 'Sint Maarten',
  },
  {
    value: 'SK',
    label: 'Slowakei',
  },
  {
    value: 'SI',
    label: 'Slowenien',
  },
  {
    value: 'SB',
    label: 'Salomon-Inseln',
  },
  {
    value: 'SO',
    label: 'Somalia',
  },
  {
    value: 'ZA',
    label: 'Südafrika',
  },
  {
    value: 'SS',
    label: 'Südsudan',
  },
  {
    value: 'ES',
    label: 'Spanien',
  },
  {
    value: 'LK',
    label: 'Sri Lanka',
  },
  {
    value: 'SD',
    label: 'Sudan',
  },
  {
    value: 'SR',
    label: 'Suriname',
  },
  {
    value: 'SE',
    label: 'Schweden',
  },
  {
    value: 'CH',
    label: 'Schweiz',
  },
  {
    value: 'SY',
    label: 'Syrische Arabische Republik',
  },
  {
    value: 'TW',
    label: 'Taiwan',
  },
  {
    value: 'TJ',
    label: 'Tadschikistan',
  },
  {
    value: 'TZ',
    label: 'Tansania',
  },
  {
    value: 'TH',
    label: 'Thailand',
  },
  {
    value: 'TL',
    label: 'Timor-Leste',
  },
  {
    value: 'TG',
    label: 'Togo Republik',
  },
  {
    value: 'TK',
    label: 'ToKelau',
  },
  {
    value: 'TO',
    label: 'Tonga',
  },
  {
    value: 'TT',
    label: 'Trinidad und Tobago',
  },
  {
    value: 'TN',
    label: 'Tunesien',
  },
  {
    value: 'TR',
    label: 'Türkische Republik',
  },
  {
    value: 'TM',
    label: 'Turkmenistan',
  },
  {
    value: 'TC',
    label: 'Turks-und Caicosinseln',
  },
  {
    value: 'TV',
    label: 'Tuvalu',
  },
  {
    value: 'UG',
    label: 'Uganda',
  },
  {
    value: 'UA',
    label: 'Ukraine',
  },
  {
    value: 'AE',
    label: 'Vereinigte Arabische Emirate',
  },
  {
    value: 'GB',
    label: 'Großbritannien',
  },
  {
    value: 'US',
    label: 'Vereinigte Staaten',
  },
  {
    value: 'US',
    label: 'Jungferninseln der Vereinigten Staaten',
  },
  {
    value: 'UY',
    label: 'Uruguay',
  },
  {
    value: 'UZ',
    label: 'Usbekistan',
  },
  {
    value: 'VU',
    label: 'Vanuatu',
  },
  {
    value: 'VE',
    label: 'Venezuela',
  },
  {
    value: 'VN',
    label: 'Vietnam',
  },
  {
    value: 'WF',
    label: 'Wallis und Futuna',
  },
  {
    value: 'YE',
    label: 'Jemen',
  },
  {
    value: 'ZM',
    label: 'Sambia',
  },
  {
    value: 'ZM',
    label: 'Zimbabwe',
  },
];
